export default [
  {
    id: 1,
    name: 'Cash'
  },
  {
    id: 2,
    name: 'Cash deposit'
  },
  {
    id: 3,
    name: 'Bank transfer'
  }
]



// WEBPACK FOOTER //
// ./src/constants/paymentTypes.js